import { Link } from "react-router-dom";

import { getFriendlyDate } from "@vellum/ui";
import { useAuth } from "@vellum/micro-app-auth";
import { isPayrollMgmt } from "@/lib/auth/roles";
import { usePayroll } from "@/lib/payroll/PayrollProvider";

export function HomePage() {
  const { user } = useAuth();
  const { payrollWindow } = usePayroll();

  return (
    <div>
      <h1 className="mb-2 text-3xl font-bold tracking-tight text-green-700">
        Vellum Payroll
      </h1>
      <p className="mb-7 max-w-xl text-sm leading-relaxed text-gray-600">
        Payroll windows, approvals, and statements for completed jobs. Current
        window: {getFriendlyDate(payrollWindow.start)} –{" "}
        {getFriendlyDate(payrollWindow.end)}.
      </p>
      <div className="grid gap-4 sm:grid-cols-2">
        <Link
          to="/my-payroll"
          className="block rounded-lg border border-gray-200 bg-white p-5 no-underline shadow-sm transition-colors hover:border-blue-500"
        >
          <h2 className="mb-1 text-lg font-semibold text-green-700">
            My Payroll
          </h2>
          <p className="m-0 text-sm text-gray-600">
            Review your completed jobs for the current window and download your
            statement once approved.
          </p>
        </Link>
        {isPayrollMgmt(user) ? (
          <Link
            to="/mgmt"
            className="block rounded-lg border border-gray-200 bg-white p-5 no-underline shadow-sm transition-colors hover:border-blue-500"
          >
            <h2 className="mb-1 text-lg font-semibold text-green-700">
              Management
            </h2>
            <p className="m-0 text-sm text-gray-600">
              Set the payroll window and approve payroll for users with
              completed jobs.
            </p>
          </Link>
        ) : null}
      </div>
    </div>
  );
}
